import { useState } from 'react';
import useCustomers from '../../../../hooks/useCustomers';
import './DeviceTab.scss';
import { formatDate } from '../../../../helpers/utils/date';
import { Loader } from '@piggytechng/component-library';
import ModalExecuteAction from '../../../../components/Modals/ModalExecuteAction';
import useRolePermissions from '../../../../hooks/useRolePermissions';

const DeviceTab = ({ userId }: any) => {
  const { restrictActionByRole, canPerformAction } = useRolePermissions({});

  const canDeleteDevice = canPerformAction('manageDevices', 'deleteDevice');

  const [showActionModal, setShowActionModal] = useState(false);

  const [deviceToUnlink, setDeviceToUnlink] = useState<string | null>(null);

  const { userDevices, unlinkUserDevice, isLoadingUserDevices, isLoading } = useCustomers();

  const unlinkAction = (deviceId: string) => {
    if (restrictActionByRole('manageDevices', 'deleteDevice')) return;
    setDeviceToUnlink(deviceId);
    setShowActionModal(true);
  };

  const handleAction = async () => {
    deviceToUnlink && unlinkUserDevice(userId, deviceToUnlink, () => setShowActionModal(false));
  };

  return (
    <>
      {isLoadingUserDevices ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <div className="device-manager-tab">
          <br />
          {userDevices && userDevices.length === 0 && (
            <div className="no-data">
              <h2>No devices linked to this User</h2>
            </div>
          )}

          {userDevices && userDevices.length > 0 && (
            <div className="table-container  manage-devices">
              <table className="table">
                <thead className="table_head">
                  <tr>
                    <th className="id">Device ID</th>
                    <th className="name"> Device Name</th>
                    <th className="status">Status</th>
                    <th className="date">Last Seen</th>
                    <th className="action"></th>
                  </tr>
                </thead>

                <tbody className="table-body">
                  {userDevices?.map((device: any) => {
                    return (
                      <tr key={device.deviceId} className="table-row">
                        <td className="id" title={device.deviceI}>
                          {device.deviceId}
                        </td>
                        <td className="name">{device.name}</td>
                        <td className="status">{device.status}</td>
                        <td className="date">
                          {formatDate(device.lastSeen).readableDate + ' | ' + formatDate(device.lastSeen).time}
                        </td>

                        <td className="action">
                          {canDeleteDevice && (
                            <button className="pointer" onClick={() => unlinkAction(device.deviceId)}>
                              Unlink
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <ModalExecuteAction
        text={'Unlink this device?'}
        actionColor={'#1734CA'}
        action={handleAction}
        buttonText={'Yes'}
        modalIsOpen={showActionModal}
        isLoading={isLoading}
        setIsOpen={setShowActionModal}
      />
    </>
  );
};

export default DeviceTab;
